import Blue from "~/core";

new Blue({
  name: 'TopicLists',
  selector: ".topicList",
  setup(container) {
		const showMoreBtn = container.querySelector("button.topics-showMore");
		const topicsListElement = container.querySelector(".topicList-topics");
		const initialShowCount = parseInt(container.getAttribute("data-initial-show-count"));
		const showMoreCount = parseInt(container.getAttribute("data-show-more-count"));
		const topics = [...container.querySelectorAll(".topics-item")];
		let amountShowing = 0;

		if (topics.length > showMoreCount) {
			showMoreBtn.classList.add("showing");
		}

		// Show topics when page loads based on initialShowCount
		topics.forEach((topic, i) => {
			if (i < initialShowCount) {
				topic.classList.add("showing");
				topic.removeAttribute("aria-hidden");
			} else {
				topic.setAttribute("aria-hidden", "true");
			}
		});
		amountShowing = initialShowCount;

		const showMore = () => {
			// height variables used for FLIP animation
			const startingListHeight = topicsListElement.offsetHeight;
			// show next round of topics based on index in topics array and
			// current number showing/number we want to add
			topics.forEach((topic, i) => {
				if (i < amountShowing + showMoreCount && i >= amountShowing) {
					topic.classList.add("showing");
					topic.removeAttribute("aria-hidden");
				}
			});
			const endingListHeight = topicsListElement.offsetHeight;
			// FLIP animation concludes below
			topicsListElement.animate([
				{height: `${startingListHeight}px`},
				{height: `${endingListHeight}px`},
			], {
				duration: 400,
				easing: 'ease'
			});
			amountShowing += showMoreCount;
			// get rid of show more btn if none left to show
			if (amountShowing >= topics.length) {
				showMoreBtn.classList.remove("showing");
			}
		}

		this.$addEvents(showMoreBtn, "click.prevent", showMore);

  }
});